import { render } from "./RegularTables.vue?vue&type=template&id=2c72f6bd"
import script from "./RegularTables.vue?vue&type=script&lang=js"
export * from "./RegularTables.vue?vue&type=script&lang=js"

import "./RegularTables.vue?vue&type=style&index=0&id=2c72f6bd&lang=css"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__